import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const AppCardStyle = makeStyles({
  cardDimensions: {
    width: 325,
    height: 266,
    marginBottom: 24,
    boxShadow: '5px 4px 5px 0 rgba(0,0,0,0.07)',
    '&&:hover': {
      boxShadow: '5px 4px 5px 0 rgba(0,0,0,0.37)',
      cursor: 'pointer',
      filter: 'brightness(95%)',
    },
  },
  aHref: {
    textDecoration: 'none',
  },
  paddingInCard: {
    height: '100%',
  },
  hundredDimensions: {
    height: '100%',
    width: '100%',
  },
  titleSettings: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '18px',
  },
  descriptionSettings: {
    fontWeight: 300,
    fontSize: 14,
    lineHeight: '20px',
  },
  img: {
    color: '#42AFE4',
    verticalAlign: 'bottom',
    width: 72,
    height: 72,
  },
  imageContainer: {
    height: 140,
    width: '100%',
    justifySelf: 'center',
    background: 'rgba(157, 213, 241, 0.1)',
  },
  flex: {
    display: 'flex',
    padding: 15,
  },
});

/**
 * Componente de carta donde se muestra un icono correspondiente a la aplicación y
 * al nombre de ésta.
 * @returns
 */
const AppCard = ({
  image,
  name,
  tooltip,
  link,
}: {
  readonly image: string;
  readonly name: string;
  readonly tooltip: string;
  readonly link: string;
}) => {
  const classes = AppCardStyle();

  return (
    <Grid className={classes.cardDimensions}>
      <a href={link} className={classes.aHref}>
        <Paper className={classes.hundredDimensions}>
          <Grid
            container={true}
            item={true}
            className={classes.paddingInCard}
            wrap="nowrap"
            direction="column"
          >
            <Grid
              item={true}
              className={classes.imageContainer}
              container={true}
              alignItems="center"
              justify="center"
            >
              <Grid item={true}>
                <img src={image} className={classes.img} style={{ width: '100%' }} alt="" />
              </Grid>
            </Grid>
            <Grid item={true} className={classes.flex}>
              <Typography className={classes.titleSettings}>{name}</Typography>
            </Grid>
            <Grid item={true} className={classes.flex}>
              <Typography className={classes.descriptionSettings}>{tooltip}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </a>
    </Grid>
  );
};

export default AppCard;
